import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_CENTER } from "../../../services/api/api";
import { RootState } from "../../Store";
import { Certificate } from "crypto-pro";
import { USER } from "../../../types";
import { INotificationHistory } from "../notificationsSlice/notificationsSlice";
import { IRouting } from "../routingSlice/routingSlice";
import { ApplicationBankStatus } from "../../../utils/guards/ApplicationBankStatusGuard/types";
import {
  ApplicationBankList,
  ApplicationBankTatBgStatus,
  Bank,
} from "../../types/applicationBankList.type";
import { Underwriter } from "../../../components/Application/UnderwriterChangeModal/UnderwriterList/UnderwriterList";
import { BgType } from "../../types/application.type";

export interface ApplicationBanks {
  id: number;
  application_id: number;
  status_id: number;
  bank_id: number;
  is_enabled: boolean;
  platform_app_id: number | null;
  platform_sum_bg: string;
  status: ApplicationBankTatBgStatus;
  bank: Bank;
  created_at: string;
  overstatement: string;
  base_commission: string;
  modified_bank_status: ApplicationBankStatus;
}
export interface PurchaseLot {
  id: number;
  ikz: string;
  initial_price: string;
  inn_customer: number;
  name_customer: string;
  name_lot: string;
  sum_bg_execution: string;
  sum_bg_obligation: string;
  sum_avance: string;
  sum_bg: string;
  number_lot: number;
  total_sum: string;
}

export interface Purchase {
  id: number;
  purchase_number: string;
  fz: string;
  subject_contract: string;
  is_closed: boolean;
  is_reprovision: boolean;
  is_sole_supplier: boolean;
  is_indisputable: boolean;
  purchase_lot: PurchaseLot | null;
  link: string;
  purchase_end_at: string | null;
  purchase_total_at: string | null;
}

export interface dataResult {
  owner?: string;
  inn_ul?: string;
  inn?: string;
  thumbprint?: string;
}

type Position =
  | "DEFAULT"
  | "CSP"
  | "REGISTER_CSP"
  | "REGISTER_AGENT"
  | "MESSAGE_EMAIL";

export type TypeInitialState = {
  success: boolean;
  token: string;
  typePosition: Position;
  LoadingPage:
    | "LOADING"
    | "COMPLICATED"
    | "LOGIN"
    | "PREV_COMPLICATED"
    | "REGISTER_CSP"
    | "REGISTER_AGENT";
  data: Data;
  emailSuccessRegisration: string;
  CSP: CSP;
};
export type CSP = { DEFAULT_CSP?: Certificate[]; CSP_FILTER: dataResult[] };
export type TypeDATA_ALL_PAGE = {
  success: boolean;
  data: Data;
};
type Organization = {
  id: number;
  inn: string;
  ogrn: string;
  name: string;
  phone_number: null | string;
  email: null | string;
  snils: null | string;
  created_at: string;
  updated_at: string;
};

export interface Contact {
  id: number;
  user_id: number;
  surname: string;
  name: string;
  patronymic: string;
  email: string;
  phone_number: string;
}

export type User = {
  id: number;
  organization_id: null | number;
  organization: Organization | null;
  role_id: number;
  surname: string;
  name: string;
  patronymic: string;
  email: string;
  image_path: string;
  inn: string;
  phone_number: string;
  type: USER;
  contacts?: Contact[];
};
interface IREGISTER_AGENT
  extends Omit<
    User,
    | "organization_id"
    | "role_id"
    | "id"
    | "organization"
    | "role_id"
    | "image_path"
    | "type"
  > {
  password: string;
  password_confirmation: string;
}

type IOrganization = {
  id: number;
  inn: string;
  ogrn: string;
  name: string;
  phone_number: string | null;
  email: string | null;
  snils: string | null;
  created_at: string;
  updated_at: string;
};

type Agent = {
  id: number;
  organization_id: number;
  role_id: number;
  surname: string;
  name: string;
  patronymic: string | null;
  email: string;
  image_path: string;
  inn: string;
  phone_number: string | null;
  type: string;
  is_banned: boolean;
  organization: IOrganization | null;
  is_enabled: boolean;
};

type Client = {
  id: number;
  organization_id: number;
  role_id: number;
  surname: string;
  name: string;
  patronymic: string | null;
  email: string;
  image_path: string;
  inn: string;
  phone_number: string | null;
  type: string;
  is_banned: boolean;
  organization: IOrganization | null;
  is_enabled: boolean;
};

type Report = {
  str1: string;
  str2: string;
  num1: number;
  num2: number;
  bool: boolean;
};

type BankStatus = {
  color: string;
  id: number;
  info: string;
  info_color: string;
  title: string;
};

type BankEmployee = {
  id: number;
  name: string;
  patronymic: string;
  surname: string;
};

type Data = {
  user: User;
  routes?: IRouting[];
  banks?: Bank[];
  agents?: Agent[];
  clients?: Client[] | IOrganization[];
  report?: Report;
  applicationBanks?: { data: ApplicationBankList; last_page: number };
  type_bg_list?: BgType[];
  bank_statuses?: BankStatus[];
  alerts: INotificationHistory[];
  underwriters: Underwriter[];
  bankEmployees: BankEmployee[];
  availableBankStatuses: ApplicationBankStatus[];
};
type TypeAuthorization = {
  email: string;
  password: string;
};
type TypeLOGOUT_USER = {
  success: string;
  messege: string;
};
const prevState: Data = {
  user: {
    id: 0,
    organization_id: null,
    organization: null,
    role_id: 0,
    surname: "",
    name: "",
    patronymic: "",
    email: "",
    image_path: "",
    inn: "",
    phone_number: "",
    type: USER.UNDERWRITER,
  },
  routes: [
    {
      title: "",
      routes: [
        {
          id: 0,
          icon: "",
          is_side: true,
          to: "/",
          element: "PageApplications",
          content: "Заявки",
        },
      ],
    },
  ],
  report: {
    str1: "",
    str2: "",
    num1: 0,
    num2: 0,
    bool: true,
  },
  applicationBanks: {
    data: [],
    last_page: 0,
  },
  alerts: [],
  underwriters: [],
  bankEmployees: [],
  availableBankStatuses: [],
};

const API = new API_CENTER();
// возможно баги с этой функцией надо будет протестить после уже готовых данных от БЭК !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
const initialState = (): TypeInitialState => {
  const stateString = localStorage.getItem("auth");
  const typePosition = localStorage.getItem("typePosition") as Position;
  if (stateString) {
    const state: TypeInitialState = JSON.parse(stateString);
    const { success, token } = state;
    if (success && token.length >= 0 && (state as TypeInitialState)) {
      return {
        success: true,
        token: token,
        typePosition: "DEFAULT",
        LoadingPage: "LOADING",
        data: prevState,
        emailSuccessRegisration: "",
        CSP: { DEFAULT_CSP: [], CSP_FILTER: [] },
      };
    }
  }
  return {
    success: false,
    token: "",
    typePosition: typePosition ? typePosition : "DEFAULT",
    LoadingPage: "LOGIN",
    data: prevState,
    emailSuccessRegisration: "",
    CSP: { DEFAULT_CSP: [], CSP_FILTER: [] },
  };
};
export const API_AUTH_AGENT = createAsyncThunk<
  TypeInitialState,
  TypeAuthorization,
  {
    rejectValue: TypeInitialState; // указывает, что функция должна возвращать TypeReturnToken или выбрасывать ошибку типа unknown
  }
>("authSlice/API_AUTH_AGENT", async (value, { rejectWithValue }) => {
  const response = await API.useAxios("kamkombank/login", "POST", value);
  if (response.success) {
    localStorage.setItem("auth", JSON.stringify(response));
    return response as TypeInitialState;
  } else {
    return rejectWithValue(response); // выбросить ошибку с сообщением
  }
});

// Нужно Затипизировать обязательно как будут готовы все данные на пред Загрузку
export const API_AUTH_CSP = createAsyncThunk<
  TypeInitialState,
  { thumbprint: string; type: "login" | "registration" },
  {
    rejectValue: TypeInitialState; // указывает, что функция должна возвращать TypeReturnToken или выбрасывать ошибку типа unknown
  }
>("authSlice/API_AUTH_CSP ", async (value, { rejectWithValue }) => {
  const config_link = `/csp/${value.type}`;
  const response = await API.configAxios(
    config_link,
    {
      method: "POST",
      responseType: "x-www-form-urlencoded",
      data: { SignedToken: value.thumbprint },
    },
    false
  );
  if (response.success) {
    if (value.type === "login") {
      return response as TypeInitialState;
    }
    if (value.type === "registration") {
      return initialState();
    }
    return initialState();
  } else {
    return rejectWithValue(response); // выбросить ошибку с сообщением
  }
});
// export const DATA_ALL_PAGE = createAsyncThunk<
//   TypeDATA_ALL_PAGE,
//   undefined,
//   {
//     rejectValue: string;
//     // указывает, что функция должна возвращать TypeReturnToken или выбрасывать ошибку типа unknown
//   }
// >("authSlice/DATA_ALL_PAGE", async (_, { rejectWithValue }) => {
//   try {
//     const response = await API.GET_API("permission", "GET").then((response) => {
//       if (response.success) {
//         return response;
//       }

//       throw new Error(response);
//     });
//     return response;
//   } catch (e) {
//     return rejectWithValue(`${e}`);
//   }
// });

export const LOGOUT_USER = createAsyncThunk<
  TypeLOGOUT_USER,
  undefined,
  {
    rejectValue: string;
    // указывает, что функция должна возвращать TypeReturnToken или выбрасывать ошибку типа unknown
  }
>("authSlice/LOGOUT_USER", async (_, { rejectWithValue }) => {
  try {
    const response = await API.GET_API("logout", "POST").then((response) => {
      if (response.success) {
        return response;
      }
      throw new Error(response);
    });
    return response;
  } catch (e) {
    return rejectWithValue(`${e}`);
  }
});
export const REGISTER_USER = createAsyncThunk<
  string,
  IREGISTER_AGENT,
  {
    rejectValue: { message: string; email: string };
    // указывает, что функция должна возвращать TypeReturnToken или выбрасывать ошибку типа unknown
  }
>("authSlice/REGISTER_USER", async (value, { rejectWithValue }) => {
  const response = await API.useAxios("registration", "POST", value);
  if (response.success) {
    return value.email;
  } else {
    return rejectWithValue({ message: response.message, email: value.email });
  }
});
export const VERIFICATION_EMAIL = createAsyncThunk<
  string,
  string,
  {
    rejectValue: TypeInitialState; // указывает, что функция должна возвращать TypeReturnToken или выбрасывать ошибку типа unknown
  }
>("authSlice/VERIFICATION_EMAIL", async (value, { rejectWithValue }) => {
  const response = await API.useAxios(
    "email/verification-notification",
    "POST",
    { email: value }
  );
  if (response.success) {
    return response;
  } else {
    return rejectWithValue(response); // выбросить ошибку с сообщением
  }
});
export const PASSWORD_RECOVERY_MAIL = createAsyncThunk<
  string,
  string,
  {
    rejectValue: TypeInitialState; // указывает, что функция должна возвращать TypeReturnToken или выбрасывать ошибку типа unknown
  }
>("authSlice/PASSWORD_RECOVERY_MAIL", async (value, { rejectWithValue }) => {
  const response = await API.useAxios("forgot-password", "POST", {
    email: value,
  });
  if (response.success) {
    return response;
  } else {
    return rejectWithValue(response); // выбросить ошибку с сообщением
  }
});

// данные о пользрвателе
const authSlice = createSlice({
  name: "AUTH_SLICE",
  initialState: initialState(), // изначально пользователь не авторизован
  reducers: {
    TYPE_POSTION: (state, action) => {
      state.typePosition = action.payload;
      localStorage.setItem("typePosition", action.payload);
    },
    // страница загрузки
    LOADING_PAGE: (state, action) => {
      state.LoadingPage = action.payload;
    },
    // запись эцп
    CSP_CERTIFICATE: (state, action: { payload: CSP }) => {
      state.CSP = action.payload;
    },
    // обновление статуса банка
    UP_DATE_BANK_STATUSES: (state, action: { payload: BankStatus[] }) => {
      state.data.bank_statuses = action.payload;
    },
    // аутентификация агента
    AUTH_AGENT: (state, action) => {
      state.LoadingPage = "LOADING";
      state.success = action.payload.success;
    },
    // записать все данные об аунтефикации
    DATA_ALL: (state, action) => {
      if (action.payload.success) {
        return {
          ...state,
          success: action.payload.success,
          data: action.payload.data,
          LoadingPage: "PREV_COMPLICATED",
        };
      }
    },
    // добавить новый контакт агенту
    ADD_CONTACT_PERSON: (state, actions: { payload: Contact }) => {
      if (actions.payload) {
        state.data.user?.contacts?.push(actions.payload);
      }
    },
    // удалить контакт у агента
    DELETE_CONTACT_PERSON: (state, actions: { payload: number }) => {
      if (actions.payload) {
        state.data.user.contacts = state.data.user?.contacts?.filter(
          ({ id }) => actions.payload !== id
        );
      }
    },
    // обновить контакт у агента
    UPDATE_CONTACT_PERSON: (state, actions: { payload: Contact }) => {
      if (actions.payload) {
        state.data.user.contacts = state.data.user?.contacts?.map((value) =>
          value.id === actions.payload.id ? actions.payload : value
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(API_AUTH_AGENT.fulfilled, (state, action) => {
      if (action.payload) {
        return {
          ...state,
          LoadingPage: "LOADING",
          success: action.payload.success,
        };
      }
    });
    builder.addCase(API_AUTH_CSP.fulfilled, (state, action) => {
      if (action.payload.success) {
        return {
          ...state,
          LoadingPage: "LOADING",
          success: action.payload.success,
        };
      }
    });
    // builder.addCase(DATA_ALL_PAGE.fulfilled, (state, action) => {
    //   if (action.payload.success) {
    //     return {
    //       ...state,
    //       success: action.payload.success,
    //       data: action.payload.data,
    //       LoadingPage: "PREV_COMPLICATED",
    //     };
    //   }
    // });
    builder.addCase(LOGOUT_USER.fulfilled, (state, action) => {
      if (action.payload.success) {
        window.location.replace("/login");
        state = {
          emailSuccessRegisration: "",
          success: false,
          token: "",
          typePosition: "DEFAULT",
          LoadingPage: "LOGIN",
          data: prevState,
          CSP: { DEFAULT_CSP: [], CSP_FILTER: [] },
        };
        localStorage.clear();
      } else {
        localStorage.clear();
        state = {
          emailSuccessRegisration: "",
          success: false,
          token: "",
          typePosition: "DEFAULT",
          LoadingPage: "LOGIN",
          data: prevState,
          CSP: { DEFAULT_CSP: [], CSP_FILTER: [] },
        };
      }
    });
    builder.addCase(REGISTER_USER.fulfilled, (state, action) => {
      if (action.payload) {
        return (state = {
          ...state,
          emailSuccessRegisration: action.payload,
          typePosition: "MESSAGE_EMAIL",
        });
      }
    });
    builder.addCase(REGISTER_USER.rejected, (state, action) => {
      if (
        action.payload &&
        action.payload.message === "Такое значение поля email уже существует."
      ) {
        return (state = {
          ...state,
          emailSuccessRegisration: action.payload.email,
          typePosition: "MESSAGE_EMAIL",
        });
      }
    });
    // builder.addCase(API_AUTH_AGENT.rejected, (state, action) => {
    //   if (action.payload) {
    //     return (state = { ...action.payload, typePosition: "DEFAULT" }); // возвращаем новое значение state
    //   }
    // });
    builder.addCase(API_AUTH_CSP.rejected, (state, action) => {
      if (action.payload) {
        return (state = { ...state, typePosition: "CSP" }); // возвращаем новое значение state
      }
    });
    // builder.addCase(DATA_ALL_PAGE.rejected, () => {
    //   localStorage.clear();
    //   window.location.reload();
    // });
    builder.addCase(LOGOUT_USER.rejected, () => {
      localStorage.clear();
      window.location.replace("/login");
    });
  },
});

export const selectAuth = (state: RootState) => state.authSlice;
export const {
  TYPE_POSTION,
  LOADING_PAGE,
  CSP_CERTIFICATE,
  UP_DATE_BANK_STATUSES,
  AUTH_AGENT,
  DATA_ALL,
  ADD_CONTACT_PERSON,
  DELETE_CONTACT_PERSON,
  UPDATE_CONTACT_PERSON,
} = authSlice.actions;
export const ID_USER_AUTH = (state: RootState) => state.authSlice.data.user?.id;
export default authSlice.reducer;
